/** @module Helpers */

/**
 * Validates field value and returns result of validation
 *
 * @param {string} value Validated value
 * @param {Array} validations List of validators
 * @param {Immutable.Map} otherValues Other values (used when validation is dependent on a value from another field)
 * @return {?string} Result of validation
 */
export default function getFieldError(value, validations, otherValues) {
  var errors = validations.reduce(function (errors, validation) {
    return errors.concat(validation(value, otherValues) || []);
  }, []);
  return errors[0] || null;
}